module.exports = __webpack_public_path__ + "static/media/black-trousers-formal.7d4b3447.jpg";